<div class="row m-0 d-flex align-items-center vh-100">
	<div class="col-lg-12">
		<div class="w-100 d-flex justify-content-center">
			<div class="flex-column align-items-center">
				<div class="titolo text-center">
					<img
						src="./assets/imgs/logo_open_fiber_magenta.png?v={{ assets_version }}"
						srcset="./assets/imgs/logo_open_fiber_magenta@2x.png 2x"
						class="d-block mx-auto"
					/>
				</div>
				<div class="mdi rounded titolo pb-3 text-center">
					<div>The site is currently under maintenance.</div>
					<div>Please try again in a few minutes.</div>
				</div>
			</div>
		</div>
	</div>
</div>
